import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Typography,
  Alert,
  Tooltip,
  FormControlLabel,
  Switch,
  Autocomplete
} from "@mui/material";

import {
  //getallemployeesByAirportForEdit,
  //getallemployeesByAirport,
  getDataEmployeesByAirportAndCompany
} from './logic';
import { DataGrid } from '@mui/x-data-grid';
import { Spanish } from '../../../../shared/grid-translations';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Delete from '@mui/icons-material/Delete';
import { ACTIONS } from '../../../../shared/constants';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import NewsletterContentDetail from '../../newsletter-content-detail';
import { useSnackbar } from 'notistack';
import { Hidden } from '@material-ui/core';
import { getUser } from '../../../../shared/auth-service';
import dayjs from "dayjs";

const CampaingSource = ({
  handleClose,
  handleSaveSources,
  data,
  allNewsletter,
  airports,
  employeePositions,
  customers,
  newsletterStates,
  newsletterTypes,
  assessments,
  campaignContentTypes,
  airportId,
  employeeId,
  action,
  onlyEnabledCustomerEmployees={onlyEnabledCustomerEmployees}
}) => {

  const user = getUser();
  const [name, setName] = useState(data.name);
  const [code, setCode] = useState(data.code);
  const [date, setDate] = useState(data.startDate || new Date());
  const [endDate, setEndDate] = useState(data.endDate ? data.endDate : dayjs().add(30, "day").toDate());
  const [customerId, setCustomerId] = useState(data.customerId);
  //const [newsletterTypeId, setNewsletterTypeId] = useState(data.newsletterTypeId);
  const [campaignStateId, setCampaignStateId] = useState(data.campaignStateId);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(employeeId);
  const { id } = data;
  const isDataReadOnly = action !== ACTIONS.NEW;
  const [selectedEmployeePositions, setSelectedEmployeePositions] = useState(data.employeePositions || []);
  const [selectedEmployeePositionId, setSelectedEmployeePosition] = useState(null);
  const [selectedAirports, setSelectedAirports] = useState(data.airports || []);
  const [selectedPersons, setSelectedPersons] = useState(data.personCharge || []);
  const [newsletterContents, setNewsletterContents] = useState(data.newsletterContent || []);
  const [selectedAirportId, setSelectedAirport] = useState(null);
  const [selectedAirportEmployee, setSelectedAirportEmployee] = useState(airportId);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  //const [assessmentId, setAssessmentId] = useState(data.assessmentId || null);
  const [value, setValue] = useState('1');
  const [selectedCampaignContentType,  setSelectedCampaignContentType] = useState(null);
  const [selectedNewsletter,  setSelectedNewsletter] = useState([]);
  const [selectedNameCampaign,  setNameCampaign] = useState("");
  const [selectedDescriptionCampaign,  setDescriptionCampaign] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isSwitchDisabled, setIsSwitchDisabled] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const allAirportsOption = { id: -1, code: "TODAS", name: "TODAS" };
  const airportsWithOptions = [allAirportsOption, ...airports];
  const personsWithOptions = [];
  const allEmployeePositionOption = { id: -1, code: "TODOS", name: "TODOS" };
  const employeePositionWithOptions = [allEmployeePositionOption, ...employeePositions];
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
  const [rows, setRows] = useState([]); // Estado para almacenar las filas del DataGrid
  const [userId, setUserId] = useState(data != null ? data.id : 0);
  const companyId = user.countryCode.split('-')[0];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (data) {
      // Inicializar campos básicos del formulario
      setName(data.name || "");
      setCode(data.code || "");
      setDate(data.startDate || new Date());
      setEndDate(data.endDate ? data.endDate : dayjs().add(30, "day").toDate());
      setCustomerId(data.customerId || null);
      setCampaignStateId(data.campaignStateId || null);
  
      // Inicializar listas relacionadas
      setSelectedEmployeePositions(data.employeePositions || []);
      setSelectedAirports(data.airports || []);
      setSelectedPersons(data.personCharge || []);
      
      // Mapear contenido para el DataGrid
      const mappedRows = [
        ...(data.newsletter?.map(item => ({
          id: `Circular-${item.id}`,
          name: item.name,
          type: "Circular",
        })) || []),
        ...(data.activity?.map((item, index) => ({
          id: `Actividad-${index + 1}`,
          name: item.name,
          description: item.description,
          type: "Actividad",
        })) || []),
      ];
      setRows(mappedRows);
    }
  }, [data]);
  

useEffect(() => {
    const fetchData = async () => {
      setLoadingEmployees(true);
      const employeesData = await getDataEmployeesByAirportAndCompany(selectedAirportEmployee, companyId); //isDataReadOnly ? await getallemployeesByAirportForEdit(selectedAirportEmployee, companyId) : await getallemployeesByAirport(selectedAirportEmployee);
      setEmployees(employeesData);
      setLoadingEmployees(false);
  
      // Si la acción es EDITAR, configura los valores predeterminados
      if (isDataReadOnly) {
        //console.log('selectedEmployeeId');
       // console.log(selectedEmployeeId)
        const employeeToSelect = employeesData.find(e => e.employeeId === selectedEmployeeId);
        //console.log(employeeToSelect);
        setEmployeeSelected(employeeToSelect);
      }
      // else{
      //   setSelectedCodes([]);
      // }
    };
  
    fetchData();

  }, [action, employeeId, selectedAirportEmployee, companyId]);
  
  const handleDeleteContent = (id) => {
    setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    //enqueueSnackbar("Actividad eliminada correctamente.", { variant: "success" });
  };

  const handleAddCircular = () => {
    if (selectedNewsletter) {
      if (selectedNewsletter) {
        setRows((prevRows) => [
          ...prevRows,
          {
            id: `Circular-${selectedNewsletter.id}`,
            name: selectedNewsletter.name,
            type: "Circular",
          },
        ]);
        setSelectedNewsletter(null); // Limpia la selección
      }
    }
    //console.log(rows);
  };
  
  const handleAddActivity = () => {
    if (selectedNameCampaign.trim() !== "") {
      setRows((prevRows) => [
        ...prevRows,
        {
          id: `Actividad-${Date.now()}`, // ID temporal
          name: selectedNameCampaign.trim(), // El texto ingresado
          description: selectedDescriptionCampaign.trim(),
          type: "Actividad",
        },
      ]);
      //setContent(""); // Limpia el input después de agregar
      setNameCampaign("");
      setDescriptionCampaign("");
      //setActivityCounter(activityCounter + 1); // Incrementa el contador de actividades
    }

    //console.log(rows);
  };
  

  const handleActionButton = (e, cellValues, source) => {
    e.stopPropagation();
    if (source === 'airport') {
      setSelectedAirports(selectedAirports.filter((el) => { return el.id !== cellValues.row.id; }));
    }
    if (source === 'employeePositions') {
      setSelectedEmployeePositions(selectedEmployeePositions.filter((el) => { return el.id !== cellValues.row.id; }));
    }
    if (source === 'person') {
      setSelectedPersons(selectedPersons.filter((el) => { return el.employeeId !== cellValues.row.employeeId; }));
    }
  };


  const handleAddEmployeePositions = (e) => {
    e.stopPropagation();
    if (selectedEmployeePositions.some(el => { return el.id === selectedEmployeePositionId; })) {
      return;
    }
    setSelectedEmployeePositions([...selectedEmployeePositions, employeePositionWithOptions.find(z => z.id === selectedEmployeePositionId)]);
  }

  const handleAddAirports = (e) => {
    e.stopPropagation();
    if (selectedAirports.some(el => { return el.id === selectedAirportId; })) {
      return;
    }
    setSelectedAirports([...selectedAirports, airportsWithOptions.find(z => z.id === selectedAirportId)]);
  }

  const handleAddPersons = (e) => {
    e.stopPropagation();
  
    // Validar que haya un empleado seleccionado
    if (!employeeSelected) {
      enqueueSnackbar("Por favor, seleccione una persona antes de agregar.", { variant: "warning" });
      return;
    }
  
    // Verificar si la persona ya existe en la lista
    if (selectedPersons.some(el => el.id === employeeSelected.employeeId)) {
      enqueueSnackbar("La persona ya ha sido agregada.", { variant: "info" });
      return;
    }
  
    // Agregar la persona seleccionada a la lista
    setSelectedPersons([
      ...selectedPersons, 
      {
        id: employeeSelected.employeeId,
        employeeId: employeeSelected.employeeId,
        name: `${employeeSelected.name} ${employeeSelected.lastName}`
      }
    ]);
  
    // Limpiar el Autocomplete después de agregar
    setEmployeeSelected(null);
  };
  

  const validateForm = () => {
    let errors = {};
    if (!name || !name.trim()) errors.name = "El nombre es requerido";
    if (!date) errors.date = "La fecha inicial es requerida";
    if (!endDate) errors.endDate = "La fecha final es requerida";

    const start = dayjs(date).startOf('day');
    const end = dayjs(endDate).startOf('day');
    
    if (start.isAfter(end)) errors.endDate = "La fecha inicial no puede ser mayor a la fecha final";
    if (!customerId) errors.customerId = "El cliente es requerido";
    if (!campaignStateId) errors.campaignStateId = "El tipo de campaña es requerido";
    if (!campaignStateId) errors.campaignStateId = "El estado de la campaña es requerido";
    if (!selectedAirports.length) errors.selectedAirports = "Agregue almenos un aeropuerto";
    if (!rows.length) errors.newsletterStateId = "Agregue almenos un contenido a la campaña";
    if (!selectedEmployeePositions.length) errors.newsletterStateId = "Agregue almenos un cargo";

     // Validación específica para actividades
    const activities = rows.filter((row) => row.type === "Actividad");
    const circulares = rows.filter((row) => row.type === "Circular");

    if (activities.length > 0 && selectedPersons.length === 0) {
      errors.selectedPersons = "Si hay actividades, debe haber al menos una persona encargada.";
    }

    setValidationErrors(errors);
  
    // Retorna true si no hay errores
    return Object.keys(errors).length > 0 ? errors : null;
  };


  const handleSave = () => {
     // Valida los datos antes de guardar
    const errors = validateForm();

    if (errors) {
      // Extrae los mensajes de error
      const errorMessages = Object.values(errors);

      // Muestra un mensaje genérico si hay más de un error, o el mensaje específico si es solo uno
      enqueueSnackbar(
        errorMessages.length > 1
          ? "Por favor, revise todos los campos requeridos."
          : errorMessages[0],
        { variant: "error" }
      );
      return;
    }

    // Si no hay errores, procede a guardar
    setIsSaveButtonDisabled(true);

    const dataContentFinal = rows.map(row => {
      if (row.type === "Actividad") {
        // Si la actividad ya tiene un ID, lo conservamos. Si no, lo asignamos como 0.
        const existingActivity = data.activity?.find(
          activity => activity.name === row.name && activity.description === row.description
        );
        return { ...row, id: existingActivity ? existingActivity.id : 0 };
      }
      return row; // Mantén las demás filas tal como están.
    });

     const today = dayjs().startOf('day');
     const selectedDate = dayjs(date).startOf('day');
    
     const finalStateId = selectedDate.isAfter(today) ? 2 : campaignStateId;

    handleSaveSources(
      id,
      date,
      endDate,
      finalStateId,
      name,
      customerId,
      selectedEmployeePositions,
      selectedAirports,
      dataContentFinal.filter(row => row.type === 'Circular'),
      dataContentFinal.filter(row => row.type === 'Actividad'),
      selectedPersons,
      companyId
    );

    //enqueueSnackbar("Los cambios han sido guardados con éxito.", { variant: "success" });
  };


  const handleSelectedAirport = async (e) => {
    e.stopPropagation();

    setSelectedAirportEmployee(e.target.value);

    await loadEmployeesByAirport(e.target.value);

    if (userId === 0) {
        setEmployeeSelected(null);
        //setChanges({ Base: false, Picture: false });
    } 
}

async function loadEmployeesByAirport(AirportId) {
    setLoadingEmployees(true);

    const employeesData = await getDataEmployeesByAirportAndCompany(AirportId, companyId);

    setEmployees(employeesData);

    setLoadingEmployees(false);
}

  const airportColumns = [
    { 
      field: 'code', 
      headerName: 'Base', 
      minWidth: 70, 
      flex: 1,
      renderCell: (cellValues) => {
       // console.log(cellValues);
        return cellValues.id === -1 ? "TODAS" : cellValues.code;
      }
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <IconButton
            color="error"
            onClick={(e) => handleActionButton(e, cellValues, 'airport')}
          >
            <Delete />
          </IconButton>
        );
      }
    }
  ];

  const personColumns = [    
    { 
      field: 'id', 
      headerName: 'Id', 
      hide:true,
      minWidth: 350, 
      flex: 1,
      renderCell: (cellValues) => {
        //console.log(cellValues);
        return cellValues.id === -1 ? "TODOS" : cellValues.value; 
      }
    },
    { 
      field: 'employeeId', 
      headerName: 'Cedula', 
      minWidth: 150, 
      align: 'center', 
      headerAlign: 'center',
      flex: 0.3,
      renderCell: (cellValues) => {
        //console.log(cellValues);
        return cellValues.id === -1 ? "TODOS" : cellValues.value; 
      }
    },
    { 
      field: 'name', 
      headerName: 'Nombre Completo', 
      headerAlign: 'center',
      align: 'center', 
      minWidth: 350, 
      flex: 1,
      renderCell: (cellValues) => {
        //console.log(cellValues);
        return cellValues.id === -1 ? "TODOS" : cellValues.value; 
      }
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <IconButton
            color="error"
            onClick={(e) => handleActionButton(e, cellValues, 'person')}
          >
            <Delete />
          </IconButton>
        );
      }
    }
  ];

  const employeePositionsColumns = [    
    { 
      field: 'name', 
      headerName: 'Cargo', 
      minWidth: 350, 
      flex: 1,
      renderCell: (cellValues) => {
        //console.log(cellValues);
        return cellValues.id === -1 ? "TODOS" : cellValues.value; 
      }
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <IconButton
            color="error"
            onClick={(e) => handleActionButton(e, cellValues, 'employeePositions')}
          >
            <Delete />
          </IconButton>
        );
      }
    }
  ];

  const contentColumns = [    
    { 
      field: 'id', 
      headerName: 'Id', 
      flex: 0.3,
      headerAlign: 'center',
      hide: true
    },
    { 
      field: 'type', 
      headerName: 'Tipo', 
      flex: 0.3,
      headerAlign: 'center',
    },
    { 
      field: 'name', 
      headerName: 'Nombre', 
      minWidth: 350, 
      flex: 1,
      headerAlign: 'center',
    },
    { 
      field: 'description', 
      headerName: 'Descripción', 
      minWidth: 350, 
      flex: 1,
      headerAlign: 'center',
      renderCell: (cellValues) => {
        const descriptionValue = cellValues.value ?? "-"; // Si es null o undefined, mostrar "-"
        return (
          <Typography variant="body2">
            {cellValues.value ?? "-"}
          </Typography>
        );
      }
    },
    {
      field: "EditSources",
      headerName: "Borrar",
      headerAlign: 'center',
      width: 100,
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <IconButton
            color="error"
            onClick={() => handleDeleteContent(cellValues.row.id)}
          >
            <Delete />
          </IconButton>
        );
      }
    }
  ];

  return (
    <div   >
      <Dialog
        maxWidth="xl"
        fullWidth="xl"
        open={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Detalle Campaña ${code || ''} - ${name || ''}`}
        </DialogTitle>
        <DialogContent>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange} aria-label="lab API tabs example">
                    <Tab label="Datos de la campaña" value="1" />
                    <Tab label="Contenido de la campaña" value="2" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                      <>
                        <span><i>Los campos marcados con * son obligatorios</i></span>
                        <Grid container direction="row" alignItems="center" spacing={2} sx={{ marginTop: '1px' }}>
                          <Grid item xs={1.5}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es-ES'}>
                              <FormControl fullWidth margin="dense">
                                <DesktopDatePicker
                                  label="Fecha Inicio *"
                                  inputFormat="DD/MM/YYYY"
                                  value={date}
                                  onChange={(e) => setDate(e)}
                                  renderInput={(params) => <TextField {...params} />}
                                />
                              </FormControl>
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={1.5}>
                              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es-ES'}>
                                <FormControl fullWidth={true} margin="dense">
                                  <DesktopDatePicker
                                    label="Fecha Fin *"
                                    inputFormat="DD/MM/YYYY"
                                    value={endDate}
                                    fullWidth
                                    onChange={(e) => setEndDate(e)}
                                    renderInput={(params) => <TextField {...params}  />}
                                  />
                                </FormControl>
                              </LocalizationProvider>
                            </Grid>
                          <Grid item xs={1.5}>
                            <FormControl fullWidth margin="dense">
                              <InputLabel id="state-select-label">Estado *</InputLabel>
                              <Select
                                labelId="state-select-label"
                                label="Estado *"
                                required
                                value={campaignStateId}
                                onChange={(e) => setCampaignStateId(e.target.value)}
                              >
                                {newsletterStates.map((item) => (
                                  <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl fullWidth margin="dense">
                              <TextField
                                label="Nombre"
                                placeholder="Nombre"
                                value={name || ''}
                                onChange={(e) => setName(e.target.value)}
                                required
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3.5}>
                            <FormControl fullWidth margin="dense">
                              <Autocomplete
                                id="combo-box-customers"
                                options={customers}
                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                value={customers.find((c) => c.id === customerId) || null}
                                onChange={(event, newValue) => {
                                  setCustomerId(newValue?.id);
                                  // if (newValue && newValue.isAirline) {
                                  //   setIsSwitchDisabled(false);
                                  //   setOnlyEnabledCustomerEmployees(true);
                                  // } else {
                                    setIsSwitchDisabled(true);
                                    //setOnlyEnabledCustomerEmployees(false);
                                 // }
                                }}
                                renderInput={(params) => <TextField {...params} label="Emisor/Cliente" required />}
                              />
                            </FormControl>
                        </Grid>
                        </Grid>
                        <p />
                          <p />
                          <Typography variant="h6" gutterBottom>
                            Persona(s) Encargada(s) *
                          </Typography>
                          <Grid container spacing={4}>
                            <Grid item xs={4}>
                              <FormControl fullWidth={true} margin="dense">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sx={{ marginBottom: 2 }}>
                                    <Grid container alignItems="center" justifyContent="space-between">
                                      <Grid item xs={11}>
                                        <Autocomplete
                                          noOptionsText={'Sin resultados'}
                                          disablePortal
                                          size='small'
                                          id="combo-box-demo"
                                          options={employees}
                                          getOptionLabel={(option) => option ? `${option.employeeId} - ${option.name} ${option.lastName}` : ''}
                                          value={employeeSelected}
                                          onChange={(event, newValue) => {
                                            setEmployeeSelected(newValue);
                                          }}
                                          //disabled={isDataReadOnly}
                                          renderInput={(params) => <TextField {...params} label="Empleado" />}
                                        />
                                      </Grid>
                                      <Grid item xs={1}>
                                        <IconButton
                                          disabled={!employeeSelected}
                                          color="primary"
                                          onClick={(e) => { handleAddPersons(e) }}
                                        >
                                          <AddCircleIcon />
                                        </IconButton>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={11}>
                                    <Grid container alignItems="center" justifyContent="space-between">
                                       <FormControl fullWidth={true} margin="dense">
                                          <InputLabel id="demo-simple-select-label">Base</InputLabel>
                                            <Select
                                              labelId="demo-simple-select-label"
                                              id="demo-simple-select"
                                              label="Base"
                                              size='small'
                                              value={selectedAirportEmployee}
                                              onChange={(e) => { handleSelectedAirport(e) }}
                                              //disabled={isDataReadOnly} // Deshabilita el Select si la acción es EDITAR
                                            >
                                              {airports.map(item => (
                                                <MenuItem key={item.id} value={item.id}>{item.code}</MenuItem>
                                                ))}
                                            </Select>
                                         </FormControl>
                                    </Grid>
                                    </Grid>
                                </Grid>
                              </FormControl>
                            </Grid>
                            <Grid item xs={7.5}>
                              <DataGrid style={{ height: 180 }} columns={personColumns} rows={selectedPersons} localeText={{ ...Spanish }} getRowId={(row) => row.employeeId} hideFooter={true} componentsProps={{
                                pagination: {
                                  labelRowsPerPage: ('Filas por página')
                                }
                              }} 
                              sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontWeight: 'bold', // Aplicar negrita a los títulos de las columnas
                                }}}
                              />
                            </Grid>
                          </Grid>
                          <p />
                          <p />
                          <Typography variant="h6" gutterBottom>
                            Target / Público objetivo *
                          </Typography>
                          <Grid container spacing={4}>
                            <Grid item xs={3}>
                              <FormControl fullWidth={true} margin="dense">
                                <Grid container spacing={1}>
                                  <Grid item xs={11}>
                                    <Autocomplete
                                        id="combo-box-airports"
                                        options={airportsWithOptions}
                                        getOptionLabel={(option) => option.code}
                                        fullWidth
                                        onChange={(event, newValue) => {
                                          //console.log(newValue);
                                          setSelectedAirport(newValue ? newValue.id : null);
                                        }}
                                        renderInput={(params) => (
                                          <TextField 
                                            {...params} 
                                            label="Base" 
                                          />
                                        )}
                                    />
                                  </Grid>
                                  <Grid item xs={1}>
                                    <IconButton
                                      disabled={!selectedAirportId}
                                      color="primary"
                                      onClick={(e) => { handleAddAirports(e) }}
                                    >
                                      <AddCircleIcon />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                              <FormControl fullWidth={true} margin="dense">
                                <Grid container spacing={1}>
                                  <Grid item xs={11}>
                                    <Autocomplete
                                      disablePortal
                                      id="employee-position-autocomplete"
                                      options={employeePositionWithOptions}
                                      getOptionLabel={(option) => option.name}
                                      onChange={(event, newValue) => {
                                        setSelectedEmployeePosition(newValue ? newValue.id : null);
                                      }}
                                      renderInput={(params) => 
                                        <TextField 
                                          {...params} 
                                          label="Cargo" 
                                        />}
                                    />
                                  </Grid>
                                  <Grid item xs={1}>
                                    <IconButton
                                      color="primary"
                                      disabled={!selectedEmployeePositionId}
                                      onClick={(e) => { handleAddEmployeePositions(e) }}
                                    >
                                      <AddCircleIcon />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </FormControl>
                            </Grid>
                            {/* <Grid item xs={3}>
                              <FormControl margin="normal" fullWidth>
                                <FormControlLabel 
                                 control={
                                  <Tooltip title="Permite definir si la circular será compartida únicamente con personal habilitado para la aerolínea seleccionada">
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                      <div>¿Solo Personal Habilitado Cliente?</div>
                                      <div style={{ color: OnlyEnabledCustomerEmployees ? 'green' : 'red' }}>
                                        <Switch
                                          checked={OnlyEnabledCustomerEmployees}
                                          onChange={(e) => setOnlyEnabledCustomerEmployees(e.target.checked)}
                                          disabled={isSwitchDisabled}
                                        />
                                        {OnlyEnabledCustomerEmployees ? 'Sí' : 'No'}
                                      </div>
                                  </div>
                                  </Tooltip>
                                }
                                />
                              </FormControl>
                            </Grid> */}
                          </Grid>
                          <p />
                          <Grid container spacing={2}>
                            <Grid item xs={3}>
                              <DataGrid style={{ height: 430 }} columns={airportColumns} rows={selectedAirports} localeText={{ ...Spanish }} componentsProps={{
                                pagination: {
                                  labelRowsPerPage: ('Filas por página')
                                }
                              }} 
                              sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontWeight: 'bold', // Aplicar negrita a los títulos de las columnas
                                }}}
                              />
                            </Grid>
                            <Grid item xs={9}>
                              <DataGrid style={{ height: 430 }} columns={employeePositionsColumns} rows={selectedEmployeePositions} localeText={{ ...Spanish }} componentsProps={{
                                pagination: {
                                  labelRowsPerPage: ('Filas por página')
                                }
                              }} 
                              sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontWeight: 'bold', // Aplicar negrita a los títulos de las columnas
                                }}}
                              />
                            </Grid>
                          </Grid>
                    </>
                </TabPanel>
                <TabPanel value="2">
                <Grid container spacing={2}>
                  <Grid item xs={9}>
                    <FormControl fullWidth margin="dense">
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                          <Autocomplete
                            id="combo-box-contenttype"
                            options={campaignContentTypes} 
                            getOptionLabel={(option) => option.name} 
                            onChange={(event, newValue) => setSelectedCampaignContentType(newValue?.id)} 
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Tipo contenido"
                                placeholder="Seleccione un tipo de contenido"
                              />
                            )}
                          />
                        </Grid>

                        {selectedCampaignContentType === 1 && (
                          <Grid item xs={8}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={5}>
                                <TextField
                                  fullWidth
                                  label="Nombre"
                                  placeholder="Ingrese el nombre de la actividad"
                                  required
                                  value={selectedNameCampaign}
                                  onChange={(e) => setNameCampaign(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  fullWidth
                                  label="Descripción"
                                  placeholder="Ingrese una descripción de la actividad"
                                  value={selectedDescriptionCampaign}
                                  onChange={(e) => setDescriptionCampaign(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={1}>
                                <IconButton
                                  color="primary"
                                  onClick={() => handleAddActivity(selectedNameCampaign)}
                                  disabled={!selectedNameCampaign.trim()}
                                >
                                  <AddCircleIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {selectedCampaignContentType === 2 && (
                          <Grid item xs={7} sx={{ marginLeft: 10 }}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={11}>
                                <Autocomplete
                                  id="combo-box-circular"
                                  options={allNewsletter}
                                  getOptionLabel={(option) => option.name}
                                  onChange={(event, newValue) => setSelectedNewsletter(newValue)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Circular"
                                      placeholder="Seleccione una circular"
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={1}>
                                <IconButton
                                  color="primary"
                                  onClick={handleAddCircular}
                                  disabled={!selectedNewsletter}
                                >
                                  <AddCircleIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </FormControl>
                  </Grid>
                   {/* Espaciado entre los elementos superiores y la tabla */}
                  <Grid item xs={12} sx={{ marginTop: 4 }}>
                    <Grid container justifyContent="center" alignItems="center">
                      {/* Contenedor de la tabla */}
                      <Grid item xs={10}>
                        <Box
                          sx={{
                            height: 330, // Altura de la tabla
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid #e0e0e0', // Borde opcional para resaltar
                            borderRadius: '4px',
                            padding: 2,
                          }}
                        >
                          <DataGrid
                            columns={contentColumns}
                            rows={rows}
                            localeText={{ ...Spanish }}
                            componentsProps={{
                              pagination: {
                                labelRowsPerPage: 'Filas por página',
                              },
                            }}
                            sx={{
                              width: '100%', // Tabla toma todo el ancho disponible
                              '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold',
                              },
                              '& .MuiDataGrid-cell': {
                                display: 'flex', // Asegura que el contenido sea un flexbox
                                justifyContent: 'center', // Centra horizontalmente
                                alignItems: 'center', // Centra verticalmente
                              },
                              '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold', // Aplicar negrita a los títulos de las columnas
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                  {newsletterContents.map((item, index) => {
                        return (<NewsletterContentDetail 
                              title= {item.title}
                              content= {item.content}
                              newsLetterContentTypeId= {item.newsLetterContentTypeId}
                              index = {index}
                              handleDeleteContent = {handleDeleteContent}
                          />);
                  })}
                </TabPanel>
              </TabContext>
            </Box>
        </DialogContent>
        <DialogActions sx={{ m: 3 }}>
          <Grid container spacing={0}>
              <Grid item xs={8.6}>
                <Alert severity="warning">¡Recuerde que los cambios solo se aplicaran si presiona el boton guardar!</Alert>  
              </Grid>
              <Grid item xs={0.2}>
              </Grid>  
              <Grid item xs={1}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleSave}
                      endIcon={<SaveIcon />}
                      disabled={isSaveButtonDisabled}
                    >
                      {isSaveButtonDisabled ? "Guardando..." : ACTIONS.SAVE}
                    </Button>
              </Grid>
              <Grid item xs={0.5}>
              </Grid>
              <Grid item xs={1}>
                    <Button
                      endIcon={<CancelIcon />}
                      variant="outlined"
                      onClick={() => { handleClose(false) }} autoFocus>{ACTIONS.CANCEL}</Button>
              </Grid>
          </Grid>
          
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CampaingSource;